import React from "react";
import { object } from "prop-types";
import "./profile-page.m.css";

export const EndDateText = ({ subscription }) => {
  if (subscription.expired) {
    return (
      <p styleName="expiry-plan-info">
        Subscription has been expired on:
        <span>
          {new Date(subscription.end_timestamp).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </span>
      </p>
    );
  } else {
    return (
      <>
        <div styleName="purchased-plan-info">
          <span>Purchased on:</span>
          <span>
            {new Date(subscription.created_at).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </span>
        </div>
        <div styleName="expiry-plan-info">
          <span> {subscription.recurring ? "Renews on:" : "Expires on:"}</span>
          <span>
            {new Date(subscription.end_timestamp).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </span>
        </div>
      </>
    );
  }
};

EndDateText.propTypes = {
  subscription: object,
};
